import React from "react";
import clsx from "clsx";

// import ThemeToggle from "../ThemeToggle/ThemeToggle";
import Navbar from "../Navbar/Navbar";

interface IProps {
  children: React.ReactNode;
  className?: string;
  hideNavbar?: boolean;
}

const Layout = ({ children, className, hideNavbar }: IProps) => {
  const classNames = clsx("main-container", className);

  return (
    <>
      {/* <div className="button-group header-nav mobile-only">
        <ThemeToggle />
      </div> */}
      {!hideNavbar && <Navbar />}
      <main className={classNames}>{children}</main>
    </>
  );
};

export default Layout;
